// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const WorkflowBreadcrumbs = registerClientReference(
function() { throw new Error("Attempted to call WorkflowBreadcrumbs() from the server but WorkflowBreadcrumbs is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/app/(keep)/workflows/[workflow_id]/workflow-breadcrumbs.tsx",
"WorkflowBreadcrumbs",
);